// This constants has been set to use in paging where we want to "load everything"
export const PER_PAGE_MAXIMUM = 1000
